<div class="flex items-center justify-between">
  <div class="branding"><app-branding></app-branding></div>

  @if(showToggle) {
  <a href="javascript:void(0)" (click)="toggleMobileNav.emit()"
    class="flex justify-center ng-star-inserted size-10! items-center">
    <i-tabler name="x" class="flex"></i-tabler>
  </a>
  }
</div>